// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2mVf3","fileBtn":"File_fileBtn__3JlOI","closeBtn":"File_closeBtn__2yzUv","fileSelected":"File_fileSelected__2WJDj","disabled":"File_disabled__jYcuu"};